module.exports = __webpack_public_path__ + "static/media/kakaoActive.bd9cccc5.png";